export default (maxSalary) => {
  if (maxSalary) {
    return `up to $${Math.floor(parseInt(maxSalary, 10) / 1000)}K`;
  }
  return null;
};
